// src/components/ui/alert-dialog.jsx
import * as React from "react"
import * as Radix from "@radix-ui/react-alert-dialog"

export const AlertDialog        = Radix.Root
export const AlertDialogTrigger = Radix.Trigger
export const AlertDialogPortal  = Radix.Portal
export const AlertDialogOverlay = React.forwardRef(
  (props, ref) => (
    <Radix.Overlay
      ref={ref}
      className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm"
      {...props}
    />
  )
)
export const AlertDialogContent = React.forwardRef(
  ({ className = "", ...props }, ref) => (
    <AlertDialogPortal>
      <AlertDialogOverlay />
      <Radix.Content
        ref={ref}
        className={
          "fixed left-1/2 top-1/2 z-50 w-full max-w-md -translate-x-1/2 -translate-y-1/2 "
          +"rounded-3xl border border-purple-500/20 bg-black/80 p-6 shadow-2xl "
          +className
        }
        {...props}
      />
    </AlertDialogPortal>
  )
)
export const AlertDialogHeader      = ({ children }) => <div className="space-y-2 text-center">{children}</div>
export const AlertDialogFooter      = ({ children }) => <div className="mt-6 flex justify-end gap-4">{children}</div>
export const AlertDialogTitle       = Radix.Title
export const AlertDialogDescription = Radix.Description
export const AlertDialogCancel      = Radix.Cancel
export const AlertDialogAction      = Radix.Action
